import { render, staticRenderFns } from "./carrierAnalysed.vue?vue&type=template&id=dead9290&scoped=true&"
import script from "./carrierAnalysed.vue?vue&type=script&lang=js&"
export * from "./carrierAnalysed.vue?vue&type=script&lang=js&"
import style0 from "./carrierAnalysed.vue?vue&type=style&index=0&id=dead9290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead9290",
  null
  
)

export default component.exports